/* unplugin-vue-components disabled */import script from "./GuestLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestLogin.vue?vue&type=script&setup=true&lang=js"

import "./GuestLogin.vue?vue&type=style&index=0&id=565e683e&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-swan-h5-game/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565e683e"]])

export default __exports__